/* ACTION TYPE */

export const SET_MODAL_SEARCH_BOX_IS_OPEN = 'SET_MODAL_SEARCH_BOX_IS_OPEN';
export const setModalSearchBoxState = (isOpen) => ({
    type: SET_MODAL_SEARCH_BOX_IS_OPEN,
    isOpen,
});

